/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { isObject } from '../components/helpers/immutable';
import { reduxTools } from './actions/reduxTools';
import { shallowEqual } from '../components/helpers/utils';
import { create_UUID } from './utils';

export const xconnect = (
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  options
) => {
  const connectId = create_UUID();

  let extMapDispatchToProps = mapDispatchToProps;
  if (!mapDispatchToProps || !isObject(mapDispatchToProps)) {
    extMapDispatchToProps = (dispatch, ownProps) => ({
      ...(mapDispatchToProps ? mapDispatchToProps(dispatch, ownProps) : {}),
      dispatch
    });
  }

  const extMapStateToProps = (state, ownProps) => ({
    ...(mapStateToProps ? mapStateToProps(state, ownProps) : {}),
    callbackId: state.xcCallbackIds[connectId] || 0,
    signals: state.signals
  });

  // noinspection JSPotentiallyInvalidUsageOfThis
  return WrappedComponent =>
    connect(
      extMapStateToProps,
      extMapDispatchToProps,
      mergeProps,
      options
    )(
      class extends React.Component {
        onPropsUpdateCallBacks = new Map();
        onPropChangeEvents = new Map();

        componentDidUpdate(prevProps, prevState) {
          if (this.onPropsUpdateCallBacks.has(this.props.callbackId)) {
            this.onPropsUpdateCallBacks.get(this.props.callbackId)(this.props);
            this.onPropsUpdateCallBacks.delete(this.props.callbackId);
          }

          for (let [propKey, callBack] of this.onPropChangeEvents) {
            const prev = prevProps[propKey];
            const current = this.props[propKey];
            if (!shallowEqual(prev, current)) {
              callBack(this.props, prevProps);
            }
          }
        }

        _pushCallBack(callBack) {
          if (!callBack) return undefined;

          const callBackKey = create_UUID();
          this.onPropsUpdateCallBacks.set(callBackKey, callBack);
          return {
            [connectId]: callBackKey
          };
        }

        callAction = (action, obj, callback) => {
          this.props.dispatch(
            reduxTools.createAction(action, obj, this._pushCallBack(callback))
          );
        };

        sendSignal = (signalId, obj) => {
          this.props.dispatch(reduxTools.sendSignal(signalId, obj));
        };

        checkSignal = (signalId, onSignal) => {
          if (this.props.signals.has(signalId)) {
            onSignal(this.props.signals.get(signalId)());
          }
        };

        setState = (obj, callBack) => {
          this.props.dispatch(
            reduxTools.merge('', obj, this._pushCallBack(callBack))
          );
        };

        setStateVariable = (path, value, callBack) => {
          this.props.dispatch(
            reduxTools.set(path, value, this._pushCallBack(callBack))
          );
        };

        onPropChange = (propKey, onChange) => {
          this.onPropChangeEvents.set(propKey, onChange);
        };

        render() {
          return (
            <WrappedComponent
              {...this.props}
              //setState={this.setState}
              //setStateVariable={this.setStateVariable}
              connectId={connectId}
              callAction={this.callAction}
              sendSignal={this.sendSignal}
              checkSignal={this.checkSignal}
              onPropChange={this.onPropChange}
            />
          );
        }
      }
    );
};
